<template>
  <div class="mask">
    <div class="mask__main" v-show="visible" :style="{width: Window_Size.width + 'px',height: Window_Size.height + 'px'}">
      <div class="mask__dialog" :style="dialogStyle">
        <i class="el-icon-loading"></i> <span>{{text || '正在保存中...'}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    visible: Boolean,
    text: {
      type: String,
      default: '正在保存中...'
    }
  },
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters([
      'Window_Size',
      'TOOL'
    ]),
    dialogStyle () {
      let { PfixLeft, PfixTop, clientHeight, clientWidth } = this.TOOL;
      let obj = {
        top: (PfixTop + clientHeight / 2) + 'px',
        left: (PfixLeft + clientWidth / 2) + 'px',
        transform: 'translate(-50%, -50%)',
      }
      return obj
    }
  },
  methods: {
    close () {
      this.$emit('closeDialog');
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../style/colors";
.mask {
  &__main {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &__dialog {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 300px;
    height: 120px;
    border-radius: 10px;
    background-color: rgba(white, 0.5);
    color: $c2;
    // box-shadow: 0 0 4px rgba($c2, 0.3);
    &>span {
      margin-left: 1.2em;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/topnav/savingMask.vue